import { render, staticRenderFns } from "./ProductAddedDialogOk.vue?vue&type=template&id=8d5a7240"
import script from "./ProductAddedDialogOk.vue?vue&type=script&lang=js"
export * from "./ProductAddedDialogOk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports